import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { slugify } from "../../utils/Helpers";

declare var ko: any;

export class militaryContactEdit_template extends vnTemplate {
    protected getTemplateHtml(): string {
        return /*html*/ `
            <div class="w-form w-form-large">
                <div class="form-header">
                    <h3 class="form-title icon i-summary">Military Contact</h3>
                    <button type="button" data-bind="click: onClickCancel" class="close-button icon i-close-2"></button>
                </div>

                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group-row">
                            <div class="form-group">
                                <label class="form-label">Title</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: title, event: { blur: onTitleBlur }"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Short Name</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: shortName"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Military Base</label>
                                <select data-bind="options: bases, optionsText: 'title', optionsValue: 'id', value: idBase, optionsCaption: 'Select a base'"></select>
                            </div>
                            <div class="form-group">
                                <input id="military-contact-active" type="checkbox" data-bind="checked: status">
                                <label for="military-contact-active" class="form-label icon i-check">Active</label>
                            </div>
                        </div>

                        <div class="form-group-row">
                            <div class="form-group">
                                <label class="form-label">Phone</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: phone"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Website URL</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: websiteUri"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Website Title</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: websiteTitle"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Path</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: path"></div>
                            </div>
                        </div>

                        <div class="form-group-row">
                            <div class="form-group">
                                <label class="form-label">Street 1</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: addressStreet1"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Street 2</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: addressStreet2"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Zip Code</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: addressZipCode"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Building Number</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: addressBuildingNumber"></div>
                            </div>
                        </div>

                        <div class="form-group-row">
                            <div class="form-group">
                                <label class="form-label">Cross Street</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: addressCrossStreet"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">City</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: addressCity"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">State</label>
                                <!-- ko if: isUnitedStatesAddress -->
                                <select data-bind="options: stateOptions, optionsText: 'label', optionsValue: 'value', value: addressState, optionsCaption: 'Select a state'"></select>
                                <!-- /ko -->
                                <!-- ko ifnot: isUnitedStatesAddress -->
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: addressState"></div>
                                <!-- /ko -->
                            </div>
                            <div class="form-group">
                                <label class="form-label">Country</label>
                                <select data-bind="options: countryOptions, optionsText: 'label', optionsValue: 'value', value: addressCountry, optionsCaption: 'Select a country'"></select>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="form-label">Hours</label>
                            <textarea id="military_contact_hours" style="height: 150px" data-bind="value: hours"></textarea>
                        </div>
                        <div class="form-group">
                            <label class="form-label">Body</label>
                            <textarea id="military_contact_body" style="height: 250px" data-bind="value: body"></textarea>
                        </div>

                        <strong class="form-sub-title" data-bind="visible: id">Help Services Referencing This Contact</strong>
                        <div class="w-list-results" data-bind="visible: id">
                            <table class="list-results">
                                <thead>
                                    <tr>
                                        <th>Help Service</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody data-bind="foreach: referencedHelpServices, visible: referencedHelpServices().length > 0">
                                    <tr>
                                        <td data-bind="text: title"></td>
                                        <td>
                                            <button class="btn secondary" type="button" data-bind="click: $parent.onClickReferencedHelpService">View</button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody data-bind="visible: referencedHelpServices().length == 0">
                                    <tr>
                                        <td colspan="2">No help services reference this contact.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <strong class="form-sub-title" data-bind="visible: id">Bases Referencing This Contact</strong>
                        <div class="w-list-results" data-bind="visible: id">
                            <table class="list-results">
                                <thead>
                                    <tr>
                                        <th>Base</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody data-bind="foreach: referencedBases, visible: referencedBases().length > 0">
                                    <tr>
                                        <td data-bind="text: title"></td>
                                        <td>
                                            <button class="btn secondary" type="button" data-bind="click: $parent.onClickReferencedBase">View</button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody data-bind="visible: referencedBases().length == 0">
                                    <tr>
                                        <td colspan="2">No bases reference this contact.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="form-footer">
                    <button type="button" data-bind="click: onClickCancel" class="btn">Cancel</button>
                    <button type="button" data-bind="click: onClickSave" class="btn highlight">Save</button>
                </div>
            </div>
        `;
    }

    protected getTemplateName(): string {
        return "militaryContactEdit-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {
        const self = this;
        const vm: any = {
            id: ko.observable(null),
            idBase: ko.observable(null),
            title: ko.observable(""),
            shortName: ko.observable(""),
            status: ko.observable(true),
            phone: ko.observable(""),
            websiteUri: ko.observable(""),
            websiteTitle: ko.observable(""),
            path: ko.observable(""),
            hours: ko.observable(""),
            body: ko.observable(""),
            addressStreet1: ko.observable(""),
            addressStreet2: ko.observable(""),
            addressZipCode: ko.observable(""),
            addressBuildingNumber: ko.observable(""),
            addressCrossStreet: ko.observable(""),
            addressCity: ko.observable(""),
            addressState: ko.observable(""),
            addressCountry: ko.observable(""),
            countryOptions: ko.observableArray([]),
            stateOptions: ko.observableArray([]),
            bases: ko.observableArray([]),
            referencedHelpServices: ko.observableArray([]),
            referencedBases: ko.observableArray([]),
            onTitleBlur: function (data, event) {
                const vm = self.getTemplateViewModel();

                if (event && event.target) {
                    vm.title(event.target.value || "");
                }

                if (!self.normalizePath(vm.path())) {
                    const path = self.buildContactPath(vm.title(), vm.idBase(), vm.bases());
                    if (path) {
                        vm.path(path);
                    }
                }

                return true;
            },
            onClickCancel: function () {
                self.caller.cancel();
            },
            onClickSave: function () {
                const vm = self.getTemplateViewModel();
                const path = self.normalizePath(vm.path());

                if (!self.isValidPath(path)) {
                    alert("Path must follow /base-guide/{base-slug}/contact/{contact-path}, and must be a valid URL path.");
                    return;
                }

                self.caller.saveContact();
            },
            onClickReferencedHelpService: function (helpService) {
                self.caller.viewReferencedHelpService(helpService);
            },
            onClickReferencedBase: function (base) {
                self.caller.viewReferencedBase(base);
            }
        };
        vm.isUnitedStatesAddress = ko.computed(() => {
            return vm.addressCountry() == "United States";
        });
        vm.addressCountry.subscribe(() => {
            vm.addressState("");
        });

        return vm;
    }

    private isValidPath(path: string): boolean {
        if (typeof path !== "string") {
            return false;
        }

        if (!path.match(/^\/base-guide\/[a-z0-9]+(?:-[a-z0-9]+)*\/contact\/(.+)$/)) {
            return false;
        }

        try {
            const parsedUrl = new URL(path, window.location.origin);

            return parsedUrl.pathname === path && parsedUrl.search === "" && parsedUrl.hash === "";
        } catch (e) {
            return false;
        }
    }

    private getSelectedBase(idBase: any, bases: Array<any>): any {
        for (let i = 0; i < bases.length; i++) {
            if (String(bases[i].id) === String(idBase)) {
                return bases[i];
            }
        }

        return null;
    }

    private buildContactPath(title: string, idBase: any, bases: Array<any>): string {
        const selectedBase = this.getSelectedBase(idBase, bases);
        const baseSlug = slugify(selectedBase ? selectedBase.baseGroup : "", { preserveNumbers: true });
        const titleSlug = slugify(title, { preserveNumbers: true });

        if (!baseSlug || !titleSlug) {
            return "";
        }

        return "/base-guide/" + baseSlug + "/contact/" + titleSlug;
    }

    private normalizePath(path: string): string {
        const normalizedPath = String(path || "").trim();
        return normalizedPath && normalizedPath.charAt(0) !== "/" ? "/" + normalizedPath : normalizedPath;
    }

    public setBases(bases): void {
        this.getTemplateViewModel().bases(bases || []);
    }

    public setAddressLookups(countries, usStates): void {
        const vm = this.getTemplateViewModel();
        vm.countryOptions(this.normalizeLookupOptions(countries, false));
        vm.stateOptions(this.normalizeLookupOptions(usStates, true));
    }

    public setDefaultBase(idBase): void {
        if (idBase) {
            this.getTemplateViewModel().idBase(idBase);
        }
    }

    public setContact(contact): void {
        const vm = this.getTemplateViewModel();
        const website = contact.website || {};
        const address = contact.address || {};
        vm.id(contact.id || null);
        vm.idBase(contact.idBase || null);
        vm.title(contact.title || "");
        vm.shortName(contact.shortName || "");
        vm.status(contact.status !== false);
        vm.phone(contact.phone || "");
        vm.websiteUri(website.uri || "");
        vm.websiteTitle(website.title || "");
        vm.path(contact.path || "");
        vm.hours(contact.hours || "");
        vm.body(contact.body || "");
        vm.addressStreet1(address.street1 || "");
        vm.addressStreet2(address.street2 || "");
        vm.addressZipCode(address.zipCode || "");
        vm.addressBuildingNumber(address.buildingNumber || "");
        vm.addressCrossStreet(address.crossStreet || "");
        vm.addressCity(address.city || "");
        vm.addressCountry(address.country || "");
        vm.addressState(address.state || "");
    }

    public setReferencedHelpServices(helpServices): void {
        this.getTemplateViewModel().referencedHelpServices(helpServices || []);
    }

    public setReferencedBases(bases): void {
        this.getTemplateViewModel().referencedBases(bases || []);
    }

    public getViewModelForRequest() {
        const vm = this.getTemplateViewModel();
        return {
            id: vm.id(),
            idBase: vm.idBase(),
            title: vm.title(),
            shortName: vm.shortName(),
            status: vm.status(),
            phone: vm.phone(),
            website: {
                uri: vm.websiteUri(),
                title: vm.websiteTitle(),
            },
            path: this.normalizePath(vm.path()),
            hours: vm.hours(),
            body: vm.body(),
            address: {
                street1: vm.addressStreet1(),
                street2: vm.addressStreet2(),
                zipCode: vm.addressZipCode(),
                buildingNumber: vm.addressBuildingNumber(),
                crossStreet: vm.addressCrossStreet(),
                city: vm.addressCity(),
                state: vm.addressState(),
                country: vm.addressCountry(),
            },
        };
    }

    protected normalizeLookupOptions(lookup, useKeysAsValues: boolean): Array<any> {
        if (!lookup) {
            return [];
        }

        const keys = Array.isArray(lookup)
            ? lookup.map((value, index) => String(index))
            : Object.keys(lookup);

        return keys.map(key => {
            const label = Array.isArray(lookup) ? lookup[Number(key)] : lookup[key];
            return {
                value: useKeysAsValues ? key : label,
                label: label,
            };
        }).filter(option => option.label !== null && option.label !== undefined && option.label !== "");
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/militaryContactEdit_template.ts